/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant            
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

 function showHide(elementid){
    if (document.getElementById(elementid).style.display == 'none'){
      document.getElementById(elementid).style.display = '';
    } else {
      document.getElementById(elementid).style.display = 'none';
    }
  }

  function updateCTAButtons(variant_id, variantJSON){
    let customVariantJSON = JSON.parse(document.querySelector('#variant_json_custom').innerHTML)
    let selVariant = customVariantJSON.filter( itm => itm[variant_id] )[0];
    let selVariantQuantity = selVariant[Object.keys(selVariant)[0]]

    if (document.querySelector('.shopify-payment-button')){
      document.querySelector('.shopify-payment-button').style.display = "block" 
    }

    console.log(`Variant Quantity: ${selVariantQuantity}`);
    console.log(`Variant Quantity: ${variantJSON.available}`);

    if(parseFloat(selVariantQuantity) <= 0 && variantJSON.available){
      document.querySelector('.ProductForm__AddToCart span').innerHTML = "Pre-Order Now"
      document.querySelector('.ProductForm__AddToCart').classList.add("Button--primary")
      document.querySelector('.ProductForm__AddToCart').classList.remove("Button--secondary")
    }
    else if(!variantJSON.available){
      document.querySelector('.ProductForm__AddToCart span').innerHTML = "Ask to Order"
      document.querySelector('.ProductForm__AddToCart').removeAttribute("disabled")
      document.querySelector('.ProductForm__AddToCart').addEventListener('click', (e) => {
        e.preventDefault
        window.location.href = "/pages/contact-us-1"
      })
      if(document.querySelector('.shopify-payment-button')){
        document.querySelector('.shopify-payment-button').style.display = "none"
      }
    }
  }

  try{
    var variant = document.querySelector('.ProductForm__Variants [name="id"]'); // Gives you access to the whole variant details
    var selVariantJSON = JSON.parse(document.querySelector('#selected_variant_json').innerHTML)

    updateCTAButtons(variant.value, selVariantJSON)
  }
  catch(error){
    console.log(error)
  }
  


document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  console.log(variant);
  updateCTAButtons(variant.id, selVariantJSON);
  // let variantJSON = JSON.parse(document.querySelector('#variant_json_custom').innerHTML)
  // let selVariant = variantJSON.filter( itm => itm[variant.id] )[0]
  // let selVariantQuantity = selVariant[Object.keys(selVariant)[0]]

  // if(document.querySelector('.shopify-payment-button')) {
  //   document.querySelector('.shopify-payment-button').style.display = "block"
  // }

  // console.log(`Variant Quantity: ${selVariantQuantity}`);
  // console.log(`Variant Availability: ${selVariant.available}`);
  // console.log(`Selected Variant JSON: ${selVariant}`);

  // if(parseFloat(selVariantQuantity) <= 0 && selVariant.available){
  //   document.querySelector('.ProductForm__AddToCart span').innerHTML = "Pre-Order Now"
  //   document.querySelector('.ProductForm__AddToCart').classList.add("Button--primary")
  //   document.querySelector('.ProductForm__AddToCart').classList.remove("Button--secondary")
  // }
  // else if(!selVariant.available){
  //   document.querySelector('.ProductForm__AddToCart span').innerHTML = "Ask to Order"
  //   document.querySelector('.ProductForm__AddToCart').removeAttribute("disabled")
  //   document.querySelector('.ProductForm__AddToCart').addEventListener('click', (e) => {
  //     e.preventDefault
  //     window.location.href = "/pages/contact-us-1"
  //   })
  //   if(document.querySelector('.shopify-payment-button')){
  //     document.querySelector('.shopify-payment-button').style.display = "none"
  //   }
  // }
});


document.querySelector('.Search__Input').addEventListener('keydown', (e) => { 
  setTimeout(function() {
    e.target.value != "" ? document.querySelector('.Search__Clear').style.display = "block" : document.querySelector('.Search__Clear').style.display = "none"
  }, 500);  
})